'use strict'

import Vue from 'vue'

import CodeInput from './CodeInput.vue'
import PercentageInput from './PercentageInput.vue'
import ToolInput from './ToolInput.vue'

Vue.component('code-input', CodeInput)
Vue.component('percentage-input', PercentageInput)
Vue.component('tool-input', ToolInput)
